import PIXI from 'pixi.js/src';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const frameAnimationHelper = {
  allAnimations: [],
  allTweens: [],


  /**
   * Sets up the animation helper
   * @param {Number} fps - The frames per second to render the animation
   * @returns {undefined} undefined
   */
  init(fps) {
    this.animations = [];
    this.playing = false;
    this.fps = fps;
    this.then = Date.now();
    this.interval = 1000 / this.fps;
  },


  /**
   * Creates an animation
   * @param {HTMLElement} container - The container to render the animation into
   * @param {Array} imageArray - An array of image urls for the animation
   * @param {Number} time - The time, in seconds, to play the animation
   * @param {Boolean} loop - If the animation should loop
   * @param {Number} imageWidth - A width for the animation images
   * @param {Number} imageHeight - A height for the animation images
   * @returns {undefined} undefined
   */
  create(container, imageArray, time, loop, imageWidth, imageHeight, delay) {
    const sprites = [];
    const animation = {};

    for (let i = 0; i < imageArray.length; i++) {
      const sprite = new PIXI.Sprite(
        PIXI.loader.resources[imageArray[i]].texture
      );

      if (imageWidth) {
        sprite.width = imageWidth;
      }

      if (imageHeight) {
        sprite.height = imageHeight;
      }

      if (i > 0) {
        sprite.visible = false;
      }

      container.addChild(sprite);
      sprites.push(sprite);
    }

    animation.sprites = sprites;
    animation.step = 0;
    animation.loop = loop ? -1 : 0;
    animation.frameCount = 0;
    animation.frameInterval = (time * this.fps) / animation.sprites.length;
    animation.sprites[0].visible = true;
    animation.delay = delay ? delay : 0;

    this.allAnimations.push(animation);

    if (imageArray.length > 1) {
      this.startTween(animation, time, loop);
    }
  },


  /**
   * Starts an animation
   * @param {Object} animation - An object holding the animation data
   * @param {Number} time - The time, in seconds, to play the animation
   * @param {Boolean} loop - If the animation should loop
   * @returns {undefined} undefined
   */
  startTween(animation, time, loop) {
    const _this = this;
    const currentAnimation = animation;

    const animationTween = window.TweenLite.to(
      animation,
      time,
      {
        delay: animation.delay,
        repeat: animation.loop,
        step: animation.sprites.length - 1,
        ease: window.Linear.easeNone,
        onUpdate() {
          _this.updateFrame(animation);
        },
        onComplete() {
          this.kill();

          if (!loop) {
            _this.playing = false;
          } else {
            currentAnimation.sprites[currentAnimation.sprites.length - 1].visible = false;
            currentAnimation.sprites[0].visible = true;
            currentAnimation.step = 0;
            _this.startTween(animation, time, loop);
          }
        },
      }
    );

    this.allTweens.push(animationTween);
  },


  /**
   * Stops all animations
   * @returns {undefined} undefined
   */
  destroyAllAnimations() {
    for (let i = 0; i < this.allTweens.length; i++) {
      this.allTweens[i].kill();
    }

    for (let i = 0; i < this.allAnimations.length; i++) {
      this.allAnimations[i] = null;
    }

    this.allAnimation = [];
  },


  /**
   * Shows the correct frame for the animation
   * @param {Object} animation - An object holding the animation data
   * @returns {undefined} undefined
   */
  updateFrame(animation) {
    const currentAnimation = animation;
    const newStep = Math.ceil(currentAnimation.step);

    if (currentAnimation.step !== newStep) {
      for (let i = 0; i < currentAnimation.sprites.length; i++) {
        currentAnimation.sprites[i].visible = false;
      }

      currentAnimation.sprites[newStep].visible = true;
    }
  },
};

export default frameAnimationHelper;



/** WEBPACK FOOTER **
 ** ./assets/js/src/helpers/frame-animation.js
 **/